import { ScriptYakLogo } from '../ui/Logo'

interface AuthLayoutProps {
  children: React.ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 via-white to-brand-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <ScriptYakLogo className="h-12 mx-auto mb-5" />
          <p className="text-sm text-gray-500">
            Streamlined collaboration for pharmaceutical teams
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl ring-1 ring-gray-100 p-8">
          {children}
        </div>

        <div className="text-center mt-8 text-sm text-gray-500">
          <p>&copy; 2026 ScriptYak. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}
